const formatNumber = (value: number, toFixed: number = 2): string => {
  if (value === 0) return "0";

  const trimZeros = (num: number): string =>
    num.toFixed(toFixed).replace(/\.?0+$/, "");

  if (value < 1000) {
    return trimZeros(value);
  } else if (value < 1_000_000) {
    return `${trimZeros(value / 1000)}K`;
  } else if (value < 1_000_000_000) {
    return `${trimZeros(value / 1_000_000)}M`;
  }
  return `${trimZeros(value / 1_000_000_000)}B`;
};

export default formatNumber;
